module.exports = __webpack_public_path__ + "img/auth.c560671e.webp";